import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import { getTheme2SearchFilterFieldCss } from "utils/theme2MultiSelect";

const SEARCH_SA_LOGS_PAGE_STYLES = (isTheme2) => `
  ${isTheme2 ? `
  .search-sa-logs.search-sa-logs--theme2 .search-sa-logs-table-card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 0 !important;
  }
  ${getTheme2SearchFilterFieldCss({
    pageScopeSelector: ".search-sa-logs.search-sa-logs--theme2",
    filtersSelector: ".search-sa-logs-table-card .search-sa-logs-filters",
    rowClass: "search-sa-logs-filters-row",
    colClass: "search-sa-logs-filter-col",
  })}
  .search-sa-logs.search-sa-logs--theme2 .search-sa-logs-table-card .inventory-table-wrap {
    margin-top: 12px;
  }
  ` : ""}
  .search-sa-logs:not(.search-sa-logs--theme2) .inventory-table-wrap {
    margin-top: 10px;
  }
  .search-sa-logs-card-header.card-header {
    padding-top: 2px;
    padding-bottom: 0;
  }
  .search-sa-logs-card-header h2,
  .search-sa-logs-card-header h4 {
    font-size: 16px !important;
    margin-top: 10px;
    margin-bottom: 0;
    line-height: 1.2;
  }
  .search-sa-logs:not(.search-sa-logs--theme2) .card .card-body {
    padding: 15px;
    padding-top: 10px;
    padding-bottom: 10px !important;
  }
  .search-sa-logs.search-sa-logs--theme2 .card .card-body {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 15px;
    padding-right: 15px;
  }
  .search-sa-logs .sa-logs-records-header {
    font-weight: 600;
    font-size: 0.8rem;
    color: #333;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }
  .white-content .search-sa-logs .sa-logs-records-header {
    color: #333;
  }
  body:not(.white-content) .search-sa-logs .sa-logs-records-header {
    color: rgba(255, 255, 255, 0.7);
  }
  .sticky-stock-table .rt-table {
    width: 100%;
    min-width: 100%;
    border-collapse: collapse;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) {
    text-align: center !important;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child {
    text-align: right !important;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child) .rt-resizable-header-content {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
  .sticky-stock-table .rt-thead .rt-th:not(:last-child).-cursor-pointer .rt-resizable-header-content {
    padding-right: 2em;
  }
  .sticky-stock-table .rt-thead .rt-th:last-child .rt-resizable-header-content {
    text-align: right;
    width: 100%;
  }
  .sticky-stock-table .rt-tbody .rt-td:not(:last-child) {
    text-align: center;
    vertical-align: middle;
  }
  .sticky-stock-table .rt-tbody .rt-td:last-child {
    text-align: right;
    vertical-align: middle;
  }
  .search-sa-logs .log-action-link {
    cursor: pointer;
    text-decoration: underline;
    font-weight: 500;
  }
`;

const SALogsCards = ({ isTheme2, filters, table, tableHeader, title }) => {
  const { t } = useTranslation();
  const pageTitle = title ?? t("routes.saLogs");

  const titleHeader = (
    <CardHeader className="search-sa-logs-card-header">
      <h2 className="mb-0">{pageTitle}</h2>
    </CardHeader>
  );

  return (
    <>
      <style>{SEARCH_SA_LOGS_PAGE_STYLES(isTheme2)}</style>
      {isTheme2 ? (
        <Card className="search-sa-logs-table-card">
          {titleHeader}
          <CardBody>
            <div className="search-sa-logs-filters">{filters}</div>
            {table}
          </CardBody>
        </Card>
      ) : (
        <>
          <Card>
            {titleHeader}
            <CardBody>{filters}</CardBody>
          </Card>
          <Card className="mt-2">
            {tableHeader ? <CardHeader>{tableHeader}</CardHeader> : null}
            <CardBody className="pt-0">{table}</CardBody>
          </Card>
        </>
      )}
    </>
  );
};

export default SALogsCards;
